import React from 'react';
import { Button, Label, Loader, Table } from 'semantic-ui-react';
import { useTranslation } from 'react-i18next';

const getPriority = (rule) => {
  const has = (f) => !!rule[f];
  if (has('channel_pattern') && has('model') && has('task_type')) return 1;
  if (!has('channel_pattern') && has('model') && !has('task_type')) return 2;
  if (has('channel_pattern') && !has('model') && has('task_type')) return 3;
  if (!has('channel_pattern') && !has('model') && has('task_type')) return 4;
  return 4;
};

const priorityColors = { 1: 'teal', 2: 'olive', 3: 'yellow', 4: 'grey' };

const RulesTable = ({ rules, loading, onEdit, onDelete }) => {
  const { t } = useTranslation();

  if (loading) {
    return <Loader active inline='centered' />;
  }

  return (
    <div style={{ overflowX: 'auto' }}>
      <Table celled compact selectable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={1}>#</Table.HeaderCell>
            <Table.HeaderCell width={2}>
              {t('concurrency.table.priority')}
            </Table.HeaderCell>
            <Table.HeaderCell width={3}>
              {t('concurrency.table.channel_pattern')}
            </Table.HeaderCell>
            <Table.HeaderCell width={3}>
              {t('concurrency.table.model')}
            </Table.HeaderCell>
            <Table.HeaderCell width={2}>
              {t('concurrency.table.task_type')}
            </Table.HeaderCell>
            <Table.HeaderCell width={2}>
              {t('concurrency.table.limit')}
            </Table.HeaderCell>
            <Table.HeaderCell width={3}>
              {t('concurrency.table.actions')}
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {rules.length === 0 ? (
            <Table.Row>
              <Table.Cell colSpan='7' textAlign='center'>
                {t('concurrency.table.empty')}
              </Table.Cell>
            </Table.Row>
          ) : (
            rules.map((rule, index) => {
              const p = getPriority(rule);
              return (
                <Table.Row key={index}>
                  <Table.Cell>{index + 1}</Table.Cell>
                  <Table.Cell>
                    <Label color={priorityColors[p]} size='small'>
                      P{p}
                    </Label>
                  </Table.Cell>
                  <Table.Cell>{rule.channel_pattern || '-'}</Table.Cell>
                  <Table.Cell>{rule.model || '-'}</Table.Cell>
                  <Table.Cell>{rule.task_type || '-'}</Table.Cell>
                  <Table.Cell>{rule.limit}</Table.Cell>
                  <Table.Cell>
                    <Button size='small' onClick={() => onEdit(index)}>
                      {t('concurrency.buttons.edit')}
                    </Button>
                    <Button
                      size='small'
                      color='red'
                      onClick={() => onDelete(index)}
                    >
                      {t('concurrency.buttons.delete')}
                    </Button>
                  </Table.Cell>
                </Table.Row>
              );
            })
          )}
        </Table.Body>
      </Table>
    </div>
  );
};

export default RulesTable;
